import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    Typography
} from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import ReactComponent from '../ReactComponent';

class ModalConfirmacaoEditarVoto extends ReactComponent {
    ok = async () => {
        this.salaSessaoStore.fecharModalConfirmacaoEditarVoto();
        await this.salaSessaoStore.recuperarUrlEdicaoVoto(this.registro);
        window.open(this.registro.informacoesAdicionais.urlEdicaoVoto);
    };

    fechar = () => {
        this.salaSessaoStore.fecharModalConfirmacaoEditarVoto();
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            ok: action,
            fechar: action,
            registro: computed,
            handleClickCheckbox: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleClickCheckbox = () => {
        this.salaSessaoStore.confirmarEdicaoVoto = !this.salaSessaoStore.confirmarEdicaoVoto;
    };

    render() {
        return (
            <Fragment>
                <Dialog
                    open={this.salaSessaoStore.modalConfirmacaoEditarVoto}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle style={{ paddingTop: '20px' }}>Acessar sistema externo</DialogTitle>
                    <DialogContent>
                        <Typography
                            style={{ paddingTop: '20px', paddingBottom: '20px' }}
                            variant="body1"
                            color="inherit"
                        >
                            {'Caso a página exibida a seguir solicite login no PJe, realize o procedimento, ' +
                                'retorne à pagina da Secretaria Eletrônica e clique novamente em "EDITAR DISPOSITIVO DE VOTO NO PJe".'}
                        </Typography>
                        <FormGroup row>
                            <FormControlLabel
                                label="Não exibir essa mensagem novamente"
                                control={
                                    <Checkbox
                                        color="primary"
                                        onClick={this.handleClickCheckbox}
                                        checked={!this.salaSessaoStore.confirmarEdicaoVoto}
                                    />
                                }
                            />
                        </FormGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.fechar}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={this.ok}
                            color="primary"
                        >
                            Continuar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

export default inject('stores')(observer(ModalConfirmacaoEditarVoto));
